import React from "react";

import {
  Card,
  CardBody,
  CardTitle,
  Container,
  Row,
  Col,
  Button,
} from "reactstrap";

function IntelMain() {
  const submitEvent = new SubmitEvent("submit");
  return (
    <section className="intel-main">
      <Container>
        <Row className="mb-5" md="10">
          <Col className="text-white text-center">
            <h3 className="display-3 mt-5 text-info">Get the latest news</h3>
            <p className="lead font-weight-normal text-default mt-1">
              Blockchain intel, corporate data breach, threat actors activity 
              relevant news, plus some of our own writings! 
            </p>
            <Button
              className="btn-round btn-icon-only"
              color="default"
              href="https://www.linkedin.com/company/cryptegridy/"
              target="_blank"
              onSubmit={submitEvent}
            >
              <i className="fab fa-linkedin"></i>
            </Button>
            <Button
              className="btn-round btn-icon-only"
              color="default"
              href="https://x.com/cryptegridy"
              target="_blank"
              onSubmit={submitEvent}
            >
              <i className="fab fa-x-twitter"></i>
            </Button>
          </Col>
        </Row>
        <Row className="align-items-center">
          <Col lg="3">
            <Card
              className="card-blog card-background"
              data-animation="zooming"
            >
              <div
                className="full-background"
                style={{
                  backgroundImage:
                    "url(" + require("assets/img/blogs/job.png") + ")",
                }}
              ></div>
              <a href="/job-hunter-malware" onClick={submitEvent}>
                <CardBody>
                  <div className="content-bottom">
                    <CardTitle tag="h5">
                      Blockchain job hunters are being targeted with malware
                    </CardTitle>
                  </div>
                </CardBody>
              </a>
            </Card>
          </Col>
          <Col lg="3">
            <Card
              className="card-blog card-background"
              data-animation="zooming"
            >
              <div
                className="full-background"
                style={{
                  backgroundImage:
                    "url(" + require("assets/img/blogs/cbdc.png") + ")",
                }}
              ></div>
              <a href="/the-future-of-cbdc" onClick={submitEvent}>
                <CardBody>
                  <div className="content-bottom">
                    <CardTitle tag="h5">
                      The future of Central Bank Digital Currencies
                    </CardTitle>
                  </div>
                </CardBody>
              </a>
            </Card>
          </Col>
          <Col lg="6">
            <Card
              className="card-blog card-background"
              data-animation="zooming"
            >
              <div
                className="full-background"
                style={{
                  backgroundImage:
                    "url(" + require("assets/img/blogs/20220914_133517.png") + ")",
                }}
              ></div>
              <a href="/swrccu-leaders-conference" onClick={submitEvent}>
                <CardBody>
                  <div className="content-bottom">
                    <CardTitle tag="h5">
                     South West Regional Cyber Crime Unit Leaders Conference
                    </CardTitle>
                  </div>
                </CardBody>
              </a>
            </Card>
          </Col>
        </Row>
        <Row className="align-items-center pb-5">
          <Col lg="6">
            <Card
              className="card-blog card-background"
              data-animation="zooming"
            >
              <div
                className="full-background"
                style={{
                  backgroundImage:
                    "url(" + require("assets/img/blogs/dominica.png") + ")",
                }}
              ></div>
              <a href="/htx-mixing-service" onClick={submitEvent}>
                <CardBody>
                  <div className="content-bottom">
                    <CardTitle tag="h5">
                      Is Huobi / HTX a “compliant” exchange or just a “regulated” mixing service?
                    </CardTitle>
                  </div>
                </CardBody>
              </a>
            </Card>
          </Col>
          <Col lg="3">
            <Card
              className="card-blog card-background"
              data-animation="zooming"
            >
              <div
                className="full-background"
                style={{
                  backgroundImage:
                    "url(" + require("assets/img/sections/ashim.jpg") + ")",
                }}
              ></div>
              <a href="#pablo" onClick={submitEvent}>
                <CardBody>
                  <div className="content-bottom">
                    <h6 className="card-category text-white opacity-8">
                      Such News
                    </h6>
                    <CardTitle tag="h5">Comming Soon...</CardTitle>
                  </div>
                </CardBody>
              </a>
            </Card>
          </Col>
          <Col lg="3">
            <Card
              className="card-blog card-background"
              data-animation="zooming"
            >
              <div
                className="full-background"
                style={{
                  backgroundImage:
                    "url(" + require("assets/img/sections/twk-tt.jpg") + ")",
                }}
              ></div>
              <a href="#pablo" onClick={submitEvent}>
                <CardBody>
                  <div className="content-bottom">
                    <h6 className="card-category text-white opacity-8">
                      Much Wow
                    </h6>
                    <CardTitle tag="h5">Not Yet</CardTitle>
                  </div>
                </CardBody>
              </a>
            </Card>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default IntelMain;
